import { Action } from '@ngrx/store';

export enum UserProfileActionTypes {
  INIT_USER_PROFILE = '[Cyclops User Profile ] Init User Profile ',
  GET_USER_DETAILS = '[Cyclops User Profile ] Get User Details',
  GET_USER_DETAILS_SUCCESS = '[Cyclops User Profile ] Get User Details Success',
  GET_USER_DETAILS_FAILURE = '[Cyclops User Profile ] Get User Details Failure',
  UPDATE_USER_DETAILS = '[Cyclops User Profile ] Update User Details',
  UPDATE_USER_DETAILS_SUCCESS = '[Cyclops User Profile ] Update User Details Success',
  UPDATE_USER_DETAILS_FAILURE = '[Cyclops User Profile ] Update User Details Failure',

  UPDATE_USER_VEHICLE_DETAILS = '[Cyclops User Profile ] Update User Vehicle Details',
  UPDATE_USER_VEHICLE_DETAILS_SUCCESS = '[Cyclops User Profile ] Update User Vehicle Details Success',
  UPDATE_USER_VEHICLE_DETAILS_FAILURE = '[Cyclops User Profile ] Update User Vehicle Details Failure',

  SET_CONTEXT_DATA = '[Cyclops UserProfile ] Set Context Data',
  DELETE_USER_ACCOUNT = '[Cyclops User Profile ] Delete User Account',
  DELETE_USER_ACCOUNT_SUCCESS = '[Cyclops User Profile ] Delete User Account Success',
  DELETE_USER_ACCOUNT_FAILURE = '[Cyclops User Profile ] Delete User Account Failure',
  DELETE_USER_ORGANIZATION = '[Cyclops User Profile ] Delete User Organization',
  DELETE_USER_ORGANIZATION_SUCCESS = '[Cyclops User Profile ] Delete User Organization Success',
  DELETE_USER_ORGANIZATION_FAILURE = '[Cyclops User Profile ] Delete User Organization Failure',
  TRAIN_USER_FACE = '[Cyclops User Profile ] Train User Face',
  TRAIN_USER_FACE_SUCCESS = '[Cyclops User Profile ] Train User Face Success',
  TRAIN_USER_FACE_FAILURE = '[Cyclops User Profile ] Train User Face Failure',
  UPLOAD_USER_PROFILE = '[Cyclops User Profile ] Upload User Profile',
  UPLOAD_USER_PROFILE_SUCCESS = '[Cyclops User Profile ] Upload User Profile Success',
  UPLOAD_USER_PROFILE_FAILURE = '[Cyclops User Profile ] Upload User Profile Failure',
  RESET_STATE = '[Cyclops User Profile ] Reset State',

  UPDATE_RISK_PROFILE = '[Cyclops User Profile] Update Risk Profile',
  UPDATE_RISK_PROFILE_SUCCESS = '[Cyclops User Profile] Update Risk Profile Success',
  UPDATE_RISK_PROFILE_FAILURE = '[Cyclops User Profile] Update Risk Profile Failure',
}
export class ResetState implements Action {
  readonly type = UserProfileActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class InitUserProfile implements Action {
  readonly type = UserProfileActionTypes.INIT_USER_PROFILE;
  constructor(public payload: any) {}
}
export class SetContextData implements Action {
  readonly type = UserProfileActionTypes.SET_CONTEXT_DATA;
  constructor(public payload: any) {}
}
export class GetUserDetails implements Action {
  readonly type = UserProfileActionTypes.GET_USER_DETAILS;
  constructor(public payload: any) {}
}
export class GetUserDetailsSuccess implements Action {
  readonly type = UserProfileActionTypes.GET_USER_DETAILS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetUserDetailsFailed implements Action {
  readonly type = UserProfileActionTypes.GET_USER_DETAILS_FAILURE;
  constructor(public payload: any) {}
}
export class UpdateUserDetails implements Action {
  readonly type = UserProfileActionTypes.UPDATE_USER_DETAILS;
  constructor(public payload: any) {}
}
export class UpdateUserDetailsSuccess implements Action {
  readonly type = UserProfileActionTypes.UPDATE_USER_DETAILS_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateUserDetailsFailed implements Action {
  readonly type = UserProfileActionTypes.UPDATE_USER_DETAILS_FAILURE;
  constructor(public payload: any) {}
}
export class UpdateUserVehicleDetails implements Action {
  readonly type = UserProfileActionTypes.UPDATE_USER_VEHICLE_DETAILS;
  constructor(public payload: any) {}
}
export class UpdateUserVehicleDetailsSuccess implements Action {
  readonly type = UserProfileActionTypes.UPDATE_USER_VEHICLE_DETAILS_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateUserVehicleDetailsFailed implements Action {
  readonly type = UserProfileActionTypes.UPDATE_USER_VEHICLE_DETAILS_FAILURE;
  constructor(public payload: any) {}
}
export class DeleteUserAccount implements Action {
  readonly type = UserProfileActionTypes.DELETE_USER_ACCOUNT;
  constructor(public payload: any) {}
}
export class DeleteUserAccountSuccess implements Action {
  readonly type = UserProfileActionTypes.DELETE_USER_ACCOUNT_SUCCESS;
  constructor(public payload: any) {}
}
export class DeleteUserAccountFailed implements Action {
  readonly type = UserProfileActionTypes.DELETE_USER_ACCOUNT_FAILURE;
  constructor(public payload: any) {}
}
export class DeleteUserOrganization implements Action {
  readonly type = UserProfileActionTypes.DELETE_USER_ORGANIZATION;
  constructor(public payload: any) {}
}
export class DeleteUserOrganizationSuccess implements Action {
  readonly type = UserProfileActionTypes.DELETE_USER_ORGANIZATION_SUCCESS;
  constructor(public payload: any) {}
}
export class DeleteUserOrganizationFailed implements Action {
  readonly type = UserProfileActionTypes.DELETE_USER_ORGANIZATION_FAILURE;
  constructor(public payload: any) {}
}
export class TrainUserFace implements Action {
  readonly type = UserProfileActionTypes.TRAIN_USER_FACE;
  constructor(public payload: any) {}
}
export class TrainUserFaceSuccess implements Action {
  readonly type = UserProfileActionTypes.TRAIN_USER_FACE_SUCCESS;
  constructor(public payload: any) {}
}
export class TrainUserFaceFailed implements Action {
  readonly type = UserProfileActionTypes.TRAIN_USER_FACE_FAILURE;
  constructor(public payload: any) {}
}
export class UploadUserProfile implements Action {
  readonly type = UserProfileActionTypes.UPLOAD_USER_PROFILE;
  constructor(public payload: any) {}
}
export class UploadUserProfileSuccess implements Action {
  readonly type = UserProfileActionTypes.UPLOAD_USER_PROFILE_SUCCESS;
  constructor(public payload: any) {}
}
export class UploadUserProfileFailed implements Action {
  readonly type = UserProfileActionTypes.UPLOAD_USER_PROFILE_FAILURE;
  constructor(public payload: any) {}
}
export class UpdateRiskProfileQuestions implements Action {
  readonly type = UserProfileActionTypes.UPDATE_RISK_PROFILE;
  constructor(public payload: any) {}
}
export class UpdateRiskProfileQuestionsSuccess implements Action {
  readonly type = UserProfileActionTypes.UPDATE_RISK_PROFILE_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateRiskProfileQuestionsFailed implements Action {
  readonly type = UserProfileActionTypes.UPDATE_RISK_PROFILE_FAILURE;
  constructor(public payload: any) {}
}
export type CyclopsUserProfileActionUnion =
  | ResetState
  | InitUserProfile
  | SetContextData
  | GetUserDetails
  | GetUserDetailsSuccess
  | GetUserDetailsFailed
  | UpdateUserDetails
  | UpdateUserDetailsSuccess
  | UpdateUserDetailsFailed
  | DeleteUserAccount
  | DeleteUserAccountSuccess
  | DeleteUserAccountFailed
  | DeleteUserOrganization
  | DeleteUserOrganizationSuccess
  | DeleteUserOrganizationFailed
  | TrainUserFace
  | TrainUserFaceSuccess
  | TrainUserFaceFailed
  | UploadUserProfile
  | UploadUserProfileSuccess
  | UploadUserProfileFailed
  | UpdateUserVehicleDetails
  | UpdateUserVehicleDetailsSuccess
  | UpdateUserVehicleDetailsFailed
  | UpdateRiskProfileQuestions
  | UpdateRiskProfileQuestionsSuccess
  | UpdateRiskProfileQuestionsFailed;
